import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import React from 'react';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            let start = Math.max(1, currentPage - 2);
            let end = Math.min(totalPages, currentPage + 2);

            if (currentPage <= 3) {
                end = 5;
                start = 1;
            } else if (currentPage >= totalPages - 2) {
                end = totalPages;
                start = totalPages - 4;
            }

            if (start > 1) pages.push(1, '...');
            for (let i = start; i <= end; i++) pages.push(i);
            if (end < totalPages) pages.push('...', totalPages);
        }

        return pages;
    };

    const pages = getPageNumbers();

    return (
        <div className="flex space-x-1 items-center">
            {pages.length > 1 && currentPage >= 1 && <button
                className="px-3 py-1 rounded bg-gray-100 disabled:opacity-50"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <ChevronsLeft className="w-4" />
            </button>}

            {pages.map((page, index) => (
                <button
                    key={index}
                    className={`px-3 py-1 rounded ${page === currentPage
                        ? 'bg-blue-600 text-white'
                        : typeof page === 'number'
                            ? 'bg-gray-100'
                            : 'cursor-default'
                        }`}
                    onClick={() => typeof page === 'number' && onPageChange(page)}
                    disabled={typeof page !== 'number'}
                >
                    {page}
                </button>
            ))}

            {pages.length > 1 && currentPage >= 1 && <button
                className="px-3 py-1 rounded bg-gray-100 disabled:opacity-50"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <ChevronsRight className="w-4" />
            </button>}
        </div>
    );
};

export default Pagination;
